import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	columnHeaderExpandButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnHeaderCollapseButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnHeaderExpandButtonIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnHeaderCollapseButtonIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	columnHeaderExpandButton: {
		id: 'native-issue-table.column-header-expand-button',
		defaultMessage: 'Show all issues - expanded',
		description: 'Label for header column of expand icon',
	},
	columnHeaderCollapseButton: {
		id: 'native-issue-table.column-header-collapse-button',
		defaultMessage: 'Show all issues - collapsed',
		description: 'Label for header column of collapse icon',
	},
	columnHeaderExpandButtonIssueTermRefresh: {
		id: 'native-issue-table.column-header-expand-button-issue-term-refresh',
		defaultMessage: 'Show all work items - expanded',
		description: 'Label for header column of expand icon',
	},
	columnHeaderCollapseButtonIssueTermRefresh: {
		id: 'native-issue-table.column-header-collapse-button-issue-term-refresh',
		defaultMessage: 'Show all work items - collapsed',
		description: 'Label for header column of collapse icon',
	},
});
export default messages;
